import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";

// دریافت لیست کلمات (چانک‌های دانش) کاربر
export const getKnowledgeChunks = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/business/@me/knowledge/chunk", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    } else {
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};

// افزودن یک کلمه (چانک دانش) جدید
export const addKnowledgeChunk = async ({ accessToken, keyword, dataType, content }) => {
  try {
    const response = await axiosInstance.post(
      "/business/@me/knowledge/chunk",
      { keyword, dataType, content },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    } else {
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};

// ویرایش یک کلمه (چانک دانش) موجود
export const updateKnowledgeChunk = async ({ accessToken, entryId, keyword, dataType, content }) => {
  try {
    const response = await axiosInstance.patch(
      `/business/@me/knowledge/chunk/${entryId}`,
      { keyword, dataType, content },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    } else {
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};

// حذف یک کلمه (چانک دانش)
export const deleteKnowledgeChunk = async ({ accessToken, entryId }) => {
  try {
    const response = await axiosInstance.delete(
      `/business/@me/knowledge/chunk/${entryId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    } else {
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};

// ================================================
// تابع دانلود فایل اکسل با پشتیبانی از تعداد
// ================================================
export const downloadKnowledgeChunksExcel = async (accessToken, count = null) => {
  console.log('🔵 Starting download with count:', count);
  
  try {
    // ساخت URL با پارامتر count
    let url = "/business/@me/knowledge/chunk/export";
    if (count) {
      url += `?count=${count}`;
    }
    
    console.log('🔵 Download URL:', url);
    
    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/json, */*',
        'Cache-Control': 'no-cache',
      },
      withCredentials: true,
      responseType: 'blob',
      timeout: 30000,
    });
    
    if (response.status === 200) {
      const contentType = response.headers['content-type'] || '';
      
      if (contentType.includes('application/json')) {
        const text = await response.data.text();
        try {
          const errorData = JSON.parse(text);
          const errorMessage = errorData.error || errorData.message || "خطا در دانلود فایل";
          toast.error(errorMessage);
          return { ok: false, error: errorMessage };
        } catch {
          toast.error("خطا در دریافت فایل");
          return { ok: false, error: "خطا در دریافت فایل" };
        }
      }
      
      return { ok: true, data: response.data, headers: response.headers };
    }
    
    return { ok: false, error: "درخواست با موفقیت انجام نشد" };
    
  } catch (error) {
    console.error('Download error:', error);
    
    if (error.code === 'ECONNABORTED') {
      toast.error("زمان درخواست به پایان رسید. لطفاً دوباره تلاش کنید.");
      return { ok: false, error: "Timeout" };
    }
    
    if (error.response) {
      if (error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const errorData = JSON.parse(text);
          const errorMessage = errorData.error || errorData.message || "خطا در دانلود فایل";
          toast.error(errorMessage);
          return { ok: false, error: errorMessage };
        } catch (e) {
          toast.error("خطا در دانلود فایل");
          return { ok: false, error: "خطا در دانلود فایل" };
        }
      } else {
        const errorMessage = error.response.data?.error || error.response.data?.message || "خطا در ارتباط با سرور";
        toast.error(errorMessage);
        return { ok: false, error: errorMessage };
      }
    } else if (error.request) {
      toast.error("سرور پاسخ نمی‌دهد. لطفاً اتصال اینترنت را بررسی کنید.");
      return { ok: false, error: "No response from server" };
    } else {
      toast.error("خطا در ارسال درخواست");
      return { ok: false, error: error.message };
    }
  }
};